import { ISortable } from 'src/app/models/interfaces/sortable.interface';

export class SortDialogResult {
    public constructor(
        public canceled: boolean,
        public items: ISortable[] = null
    ) {}
}
